<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.interfaces.pageKiosk.title') }}
    </portal>
    <template v-if="config !== null">
      <template v-if="!isEmpty(config.instances)">
        <card v-for="instance in config.instances"
              :key="instance.id"
              :title="instance.name"
              :card-type="config.instances.length > 1 ? 'record' : 'default'"
              cols="12 6@desktop"
              @delete="deleteInstance(instance.id)">
          <!--          <card-badge :tooltip="$t('betaVersion.tooltip')">{{ $t('betaVersion.title') }}</card-badge>-->
          <hm-card-inner>
            <hm-input :label="$t('admin.interfaces.pageKiosk.instanceId')"
                      :disabled="true"
                      v-model="instance.id"
                      cols="12 6@hd start-1"
                      name="instanceId" />
            <hm-input :label="$t('admin.interfaces.pageKiosk.name')"
                      v-model="instance.name"
                      cols="12 6@hd start-1"
                      name="name" />
            <hm-input :value="getKioskUrl()" :disabled="true" :label="$t('admin.interfaces.pageKiosk.kioskUrl')" cols="12 6@hd start-1">
              <template slot="icon-inline-right" slot-scope="slot">
                <input-icon-button :border="true" :title="$t('admin.interfaces.pageKiosk.copyToClipboard')" icon="copy" @click="$copy(getKioskUrl())" />
              </template>
            </hm-input>
          </hm-card-inner>
          <hm-card-inner title="Gerät verbinden">
            <hm-input :label="$t('admin.interfaces.pageKiosk.pairingKey')"
                      v-model="instance.pairingKey"
                      cols="12 6@hd start-1"
                      name="pairingKey" />
            <hm-col cols="12 6@hd start-1">
              <hm-button class="btn--green"
                         icon-left="save"
                         @click="pair(instance.id, instance.pairingKey)">
                {{ $t('admin.interfaces.pageKiosk.connect') }}
              </hm-button>
            </hm-col>
          </hm-card-inner>
          <hm-card-inner v-if="!isEmpty(instance.tokens)" :title="$t('admin.interfaces.pageKiosk.card.connectedDevices')">
            <hm-col cols="12">
              <p v-for="token in instance.tokens" :key="token" class="ellipsis">{{ token }}</p>
            </hm-col>
            <hm-col cols="12 6@hd start-1">
              <hm-button class="btn--red"
                         icon-left="close"
                         @click="deleteConnections(instance.id)">
                {{ $t('admin.interfaces.pageKiosk.deleteAllConnections') }}
              </hm-button>
            </hm-col>
          </hm-card-inner>
        </card>
      </template>
    </template>
    <hm-floating-buttons>
      <hm-floating-button :throttle="3500"
                          :label="$t('admin.interfaces.pageKiosk.actions.addKiosk')"
                          icon="plus"
                          color="blue"
                          @click="addKiosk()" />
      <hm-floating-button :throttle="3500"
                          :label="$t('admin.interfaces.pageKiosk.actions.openKiosk')"
                          icon="link"
                          color="orange"
                          @click="openKiosk()" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import { isEmpty, isNil } from 'lodash';
import HmInput from '../../../lib/inputs/HmInput';

export default {
  name: 'PageKiosk',
  components: { HmInput, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        const tmp = {
          nameMap: {},
        };

        this.config.instances.forEach((it) => {
          tmp.nameMap[it.id] = it.name;
        });

        this.axios.put(this.serviceUrls.interfaces.kiosk.list(this), tmp)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isEmpty,
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.kiosk.list(this, null))
        .then((response) => {
          this.config = response.data.data;
        });
    },
    pair(instanceId, pairingKey) {
      this.axios.post(this.serviceUrls.interfaces.kiosk.pair(this, instanceId, pairingKey))
        .then((response) => {
          this.loadData();
          this.showSuccessMessage();
        })
        .catch(() => {
          this.showErrorMessage();
        });
    },
    deleteConnections(instanceId) {
      this.axios.post(this.serviceUrls.interfaces.kiosk.clearTokens(this, instanceId))
        .then((response) => {
          this.loadData();
          this.showSuccessMessage();
        })
        .catch(() => {
          this.showErrorMessage();
        });
    },
    getKioskUrl() {
      let baseUrl = 'https://checkin.hotelsoftware.io';

      switch (process.env.HOTELMEISTER_ENV) {
        case 'development':
          baseUrl = 'http://localhost:8082';
          break;
        case 'demo':
          baseUrl = 'https://checkin-staging.hotelsoftware.io';
          break;
        case 'production':
        default:
          baseUrl = 'https://checkin.hotelsoftware.io';
          break;
      }

      return `${baseUrl}/#/${this.$root.hotel}/kiosk`;
    },
    openKiosk() {
      const url = this.getKioskUrl();

      window.open(url, '_blank');
    },
    addKiosk() {
      this.axios.post(this.serviceUrls.interfaces.kiosk.list(this))
        .then((response) => {
          this.config = response.data.data;
          this.showSuccessMessage();
          this.$serviceBus.$emit('hotelSettings.update');
        })
        .catch(() => {
          this.showErrorMessage();
        });
    },
    deleteInstance(instanceId, force = false) {
      if (force) {
        this.axios.delete(this.serviceUrls.interfaces.kiosk.get(this, instanceId))
          .then((response) => {
            this.loadData();
            this.showSuccessMessage();
            this.$serviceBus.$emit('hotelSettings.update');
          })
          .catch(() => {
            this.showErrorMessage();
          });
      } else {
        this.showConfirmModal(
          this.$t('admin.interfaces.pageKiosk.confirmDelete', [instanceId]),
          (doNotShowAgain) => {
            this.deleteInstance(instanceId, true);
          },
        );
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageKiosk.vue